import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ProfileLeft from '../components/Profile/ProfileLeft';
import ProfileRight from '../components/Profile/ProfileRight';
import {apiRequest} from "../api/index";
import DefaultLayout from '../components/DefaultLayout';


const Profile = () => {
  const { id } = useParams();
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Загрузка данных пользователя
  useEffect(() => {
    let isMounted = true;
    
    const loadUserData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // 1. Если передан id из URL, загружаем данные конкретного рекламодателя
        if (id) {
          const advertiserData = await apiRequest(`users/${id}/profile`, 'GET');
          if (!isMounted) return;
          setUserData(advertiserData.data || advertiserData);
        } else {
          // 2. Если id не передан, загружаем данные авторизованного пользователя
          const userData = await apiRequest(`users/${id}/profile`, 'GET');
          if (!isMounted) return;
          console.log("userData: ", userData);
          setUserData(userData);
        }
        
      } catch (error) {
        // Проверяем, что компонент все еще смонтирован перед обновлением состояния
        if (isMounted) {
          console.error('Ошибка при загрузке данных профиля:', error);
          setError(error.message || 'Не удалось загрузить данные профиля');
        }
      } finally {
        // Проверяем, что компонент все еще смонтирован перед обновлением состояния
        if (isMounted) {
          setLoading(false);
        }
      }
    };
    
    loadUserData();
    
    // Очистка при размонтировании компонента
    return () => {
      isMounted = false;
    };
  }, [id]);



  if (error) {
    return (
      <DefaultLayout>
        <div style={{ padding: '20px', color: 'red' }}>
          {error}
        </div>
      </DefaultLayout>
    );
  }

  // if (!userData) {
  //   return (
  //       <DefaultLayout>
  //         <div className="profile-container">
  //             Загрузка..
  //         </div>
  //       </DefaultLayout>
  // )
  // }
  return (
    <DefaultLayout>
        <div className="profile-container">
          <ProfileLeft
            loading={loading}
            userData={userData} 
          />
          <ProfileRight
            loading={loading}
            userData={userData} 
          />
        </div>
      </DefaultLayout>

  );
};

export default Profile;